<template>
</template>

<script>
export default {
	name:'ui-hidden',
}
</script>

<style>
</style>